import { render, staticRenderFns } from "./prevhigh-building.vue?vue&type=template&id=3dba39dc&"
import script from "./prevhigh-building.vue?vue&type=script&lang=js&"
export * from "./prevhigh-building.vue?vue&type=script&lang=js&"
import style0 from "./prevhigh-building.vue?vue&type=style&index=0&id=3dba39dc&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports